import {
	pink,
	purple,
	blue,
	cyan,
	teal,
	green,
	lime,
	yellow,
	deepOrange,
	red,
	brown,
	blueGrey
} from '@mui/material/colors';

export const $primary = '#2196f3'; //Blue (same as MUI blue main / blue 500)

export const $danger = '#F46262'; //Red

export const $dangerLight = '#FF9999'; //Red (same as MUI red light / red 100)
export const $dangerDark = '#C94E4E'; //Red (same as MUI red dark / red 900)
export const $warning = '#F4A862'; //Orange
export const $warningLight = '#FFC68A'; //Orange (same as MUI orange light / orange 100)
export const $warningDark = '#C17E3F'; //Orange (same as MUI orange dark / orange 900)
export const $elevated = '#F4E562'; //Yellow
export const $success = '#36D18A'; //Green
export const $successLight = '#6FFFB1'; //Green (same as MUI green light / green 100)
export const $successDark = '#28A36A'; //Green (same as MUI green dark / green 900)
export const $gray = '#C4C4C4';
export const $black = '#121212';
export const $white = '#fff';

// LAANC COLORS:
export const $laancStatusAuthorized = $success;
export const $laancStatusPending = $elevated;
export const $laancStatusRejected = $warning;
export const $laancStatusCanceled = $danger;
export const $laancStatusEnded = $gray;

//Live traffic colors
export const $aircraftInfoHotPinkHighlight = '#FF69FF';
export const $bearingRangeNeonBlue = '#00c8ff';
export const $aircraftInfoLayerTextColor = '#2196f3';
export const $liveTrafficTrailColor = '#2196f3';
export const $blueLowAltitudeAircraftColor = '#2196f3';
export const $userLocationBlue = '#2196f3';
export const $lowAltitudeColor = $danger;
export const $midAltitudeColor = $elevated;
export const $highAltitudeColor = $success;

//Flight Playback
export const $altitudeIndicatorSkyColor = '#2196f3';
export const $groundBrown = '#8a4c12';
export const $flightPathPink = '#ed6498';

// CUSTOM AIRSPACE COLORS:
export const $customAirspaceFillColor = 'rgba(250, 149, 25, 0.5)';
export const $customAirspaceLineColor = 'rgba(249, 160, 6, 0.75)';
export const $customAirspacePointColor = 'rgba(249, 160, 6, 0.75)';

//Clustering colors (from MUI purple theme)
export const $clusterSmall = '#ce93d8'; //MUI 200
export const $clusterMedium = '#ab47bc'; //MUI 400
export const $clusterLarge = '#8e24aa'; //MUI 600

const colorObjects = {
	// Blues group
	blue, // Primary blue
	cyan, // Lighter blue
	teal, // Blue-green

	// Reds group
	red, // Primary red
	pink, // Light red
	deepOrange, // Dark orange-red

	// Greens group
	green, // Primary green
	lime, // Light green

	// Purples group
	purple, // Primary purple

	// Pure colors
	yellow, // Pure yellow

	// Neutrals last
	brown, // Warm neutral
	blueGrey // Cool neutral
};
export { colorObjects };

// Remove grey since it's too close to blueGrey
// Define shades in order of preference
const shades = [500, 700, 300, 900];

// Generate colors array dynamically based on needed length
export const getChartColors = neededLength => {
	const colors = [];
	const baseColors = Object.values(colorObjects);

	// First use all base colors at 500 shade
	colors.push(...baseColors.map(color => color[500]));

	// If we need more colors, start adding additional shades
	if (neededLength > baseColors.length) {
		// For each additional shade
		for (
			let shadeIndex = 1;
			shadeIndex < shades.length && colors.length < neededLength;
			shadeIndex++
		) {
			const currentShade = shades[shadeIndex];
			// Add this shade for each base color
			colors.push(...baseColors.map(color => color[currentShade]));
		}
	}

	return colors.slice(0, neededLength);
};

// For backward compatibility, export muiColors with a default reasonable size
export const muiColors = getChartColors(18); // or whatever default size you want
